import { render, staticRenderFns } from "./tablaPedidos.vue?vue&type=template&id=f125a846&scoped=true&"
import script from "./tablaPedidos.vue?vue&type=script&lang=js&"
export * from "./tablaPedidos.vue?vue&type=script&lang=js&"
import style0 from "./tablaPedidos.vue?vue&type=style&index=0&id=f125a846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f125a846",
  null
  
)

export default component.exports